import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input } from '@angular/core';
import { IWizItemRenderer, WizDatasource, WizEventManager } from '@wizeoo/akm-component-lib';
import { WidgetConfigurationItemObj, WidgetConfigurationObj } from '@wizeoo/akm-message-lib';

import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { ViewData } from '../../../../model/view.data';
import { ALK_EVENT_TYPE } from '../../../../model/enums';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { FreedataValueVO } from '../../../../vo/core/freedatavalue.vo';
import { FreedataArgsVO } from  '../../../../vo/core/freedataargs.vo';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { FreedataTileWidget } from '../freedata-tile.widget';
import { Model } from '../../../../model/model';

/**
 * Vignette de présentation d'un rôle pour l'affichage en mode vignette du MultiDisplay
 */

@Component({
  selector: 'freedata-tile-renderer',
  templateUrl: './freedata-tile.renderer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreedataTileRenderer implements IWizItemRenderer<any, FreedataValueVO> {

  @Input()
  private _provider: WizDatasource<any> = null;
  public get provider(): WizDatasource<any> {
    return this._provider;
  }
  public set provider(value: WizDatasource<any>) {
    this._provider = value;
  }

  private _context: any = null;
  public get context(): any {
    return this._context;
  }
  public set context(value: any) {
    this._context = value;
  }

  public widgets: GridsterWidgetItem[] = []; // item de travail
  private fieldsMap: Map<string, FreedataArgsVO> = new Map(); // la map des FreedataArgsVO pour le FD arg.Code = FreedataArgsVO
  public wco: WidgetConfigurationObj = null; // la conf du widget pour rendu des tuiles
  public masterTileWidget: FreedataTileWidget = null; // le widget parent pour écouteur de changement de rendu des tuiles
  
  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) {
  }

  private _owner: any;
  public get owner(): any {
    return this._owner;
  }
  public set owner(owner: any) {
    if (owner === this._owner) return; // Ne fait rien si identique
    this._owner = owner;
    this.masterTileWidget = this.owner.wizContext[0];
    WizEventManager.addListener(this, this.masterTileWidget, ALK_EVENT_TYPE.TILE_RENDERER_UPDATED, this.tileRendererUpdate);
    this.wco = this.owner.wizContext[1];
    // console.log('owner', this.owner);
    // if(!!this.data && !this.builded) {
    //   this.build();
    // }
    // 
    if(!!this.data) {
      this.build('owner');
    }
    
  }

  public get model(): Model {
    return this.masterTileWidget.model;
  }


  private tileRendererUpdate(e: AlkEvent): void {
    // console.log('tileRendererUpdate');
    
    // if (e.data === this.wco) return;
    this.wco = e.data;
    this.build('render');
    // this.cdref.markForCheck();
  }

  private _lastWcoRef: WidgetConfigurationObj = null;
  private _lastFieldsOrigin: string = null;

  private builded: boolean = false;

  private buildedDataCode: string;
  private buildedWcoId: any;



  /**
   * construction des rendus
   */
  private build(who: string): void {
      // Si déjà fait pour cette data + config, ne refait rien
      if (
        this._data?.code === this.buildedDataCode &&
        this.wco === this.buildedWcoId && who !== 'render'
      ) {
        // console.log('out', who, this.data.code);
        return;
      }

    
    if (!!this.data && !!this.wco) {
      this.buildedDataCode = this._data.code;
      this.buildedWcoId = this.wco;
      //console.log('FreedataTileRenderer build',who, this.data.code);
      // Optim : Ne reconstruit fieldsMap QUE si freeDataCode (structure) a changé
      const fdOrigin = this.data.freeDataCode;
      if (this._lastFieldsOrigin !== fdOrigin || who === 'render') {
        const fd = this.model.freedataEngine.getFreeData(this.data.freeDataCode);
        fd.resetUpdateMap();
        fd.getValuesVO();
        this.fieldsMap = new Map(
          this.data.getParentFDVO().allFieldsAsArgs.map(item => [item.code, item])
        );
        this._lastFieldsOrigin = fdOrigin;
      }

      // widgets: toujours rebuild car possible changement de config d'affichage (wco)
      // Option: tu peux aussi comparer this._lastWcoRef, mais ici on rebuild à chaque wco différent
      this.widgets = [];
      if (this.wco.ff) {
        this.wco.ff.forEach((obj: WidgetConfigurationItemObj) => {
          const arg: FreedataArgsVO = this.fieldsMap.get(obj.fdvf);
          if (!!arg) {
            const result: GridsterWidgetItem = new GridsterWidgetItem(obj, new PivotField(this.masterTileWidget, obj, null, arg)); 
            this.widgets.push(result);
          } else if(obj.fdvf === ViewData.FORM_HTML || obj.fdvf === ViewData.FORM_IMAGE || obj.fdvf === ViewData.FORM_ACTION ) {
            const result: GridsterWidgetItem = new GridsterWidgetItem(obj, new PivotField(this.masterTileWidget, obj, null, arg)); 
            this.widgets.push(result);
          } else {
            console.log('wrong widget item', obj);
          }
        });      
      }
      this._lastWcoRef = this.wco;
      if(who === 'render') {
       //  console.log('forcer render', this.data, this.fieldsMap)
        this.cdref.markForCheck();
      }
      // 
    }
  }


  // Le VO manipulé
  private _data: FreedataValueVO;
  public get data(): FreedataValueVO {
    return this._data;
  }
  public set data(data: FreedataValueVO) {
    if (this._data === data) return; // Ne rebuild que si la référence change
    
    // if(this._data && this.data !== data) {
    //   console.log('change', this._data.code, data.code);
    // }
    
    this._data = data;
    this.build('data');
  }


}

